"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Placeholder = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function evalMaybeThunk(src) {
    if (typeof src == "function") {
        return src();
    } else {
        return src;
    }
}

function otherDirection(src) {
    switch (src) {
        case "top":
            return "bottom";
        case "bottom":
            return "top";
    }
}

var Placeholder = exports.Placeholder = function (_React$Component) {
    (0, _inherits3.default)(Placeholder, _React$Component);

    function Placeholder() {
        (0, _classCallCheck3.default)(this, Placeholder);
        return (0, _possibleConstructorReturn3.default)(this, (Placeholder.__proto__ || (0, _getPrototypeOf2.default)(Placeholder)).apply(this, arguments));
    }

    (0, _createClass3.default)(Placeholder, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                className = _props.className,
                style = _props.style;

            return _react2.default.createElement("div", {
                className: (0, _classnames2.default)("cn-sticky-placeholder", className),
                ref: "stickyPlaceholderBottom"
            });
        }
    }]);
    return Placeholder;
}(_react2.default.Component);

Placeholder.propTypes = {
    className: _propTypes2.default.string,
    style: _propTypes2.default.object
};

var Sticky = function (_React$Component2) {
    (0, _inherits3.default)(Sticky, _React$Component2);

    function Sticky(props) {
        (0, _classCallCheck3.default)(this, Sticky);

        var _this2 = (0, _possibleConstructorReturn3.default)(this, (Sticky.__proto__ || (0, _getPrototypeOf2.default)(Sticky)).call(this, props));

        _this2.state = { sticky: null };

        _this2.updateSticky = _this2.updateSticky.bind(_this2);
        return _this2;
    }

    (0, _createClass3.default)(Sticky, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this3 = this;

            if (this.stickyEnabled()) {
                this.stickyInit();
                requestAnimationFrame(function () {
                    return _this3.updateSticky();
                });
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            var _this4 = this;

            if (prevState.sticky === this.state.sticky) {
                requestAnimationFrame(function () {
                    return _this4.updateSticky();
                });
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            if (this.stickyEnabled()) {
                this.stickyUninit();
            }
        }
    }, {
        key: "stickyEnabled",
        value: function stickyEnabled() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return typeof props.value == "number" || typeof props.value == "function";
        }
    }, {
        key: "stickyInit",
        value: function stickyInit() {
            window.addEventListener("resize", this.updateSticky);
            window.addEventListener("scroll", this.updateSticky);
        }
    }, {
        key: "stickyUninit",
        value: function stickyUninit() {
            window.removeEventListener("resize", this.updateSticky);
            window.removeEventListener("scroll", this.updateSticky);
        }
    }, {
        key: "setSticky",
        value: function setSticky(offset) {
            if (this.state.sticky === offset) {
                return;
            }
            this.setState({ sticky: offset });

            var _props2 = this.props,
                placeholder = _props2.placeholder,
                direction = _props2.direction;


            var dom = _reactDom2.default.findDOMNode(this);
            var placeholderReact = evalMaybeThunk(placeholder);
            var placeholderDOM = _reactDom2.default.findDOMNode(placeholderReact);
            if (!(dom && placeholderDOM)) {
                return;
            }

            placeholderDOM.style.height = dom.getBoundingClientRect().height + "px";

            dom.style.position = "fixed";
            dom.style.width = placeholderDOM.getBoundingClientRect().width + "px";
            dom.style.left = placeholderDOM.getBoundingClientRect().left + "px";
            dom.style[direction] = offset + "px";
            dom.style.zIndex = 2;
        }
    }, {
        key: "clearSticky",
        value: function clearSticky() {
            if (this.state.sticky === null) {
                return;
            }
            this.setState({ sticky: null });

            var dom = _reactDom2.default.findDOMNode(this);
            if (!dom) {
                return;
            }

            dom.style.position = "relative";
            dom.style.width = "auto";
            dom.style.top = "auto";
            dom.style.bottom = "auto";
            dom.style.left = "auto";

            var placeholderReact = evalMaybeThunk(this.props.placeholder);
            var placeholderDOM = _reactDom2.default.findDOMNode(placeholderReact);
            if (placeholderDOM) {
                placeholderDOM.style.height = 0;
            }
        }
    }, {
        key: "updateSticky",
        value: function updateSticky() {
            var _props3 = this.props,
                value = _props3.value,
                placeholder = _props3.placeholder,
                direction = _props3.direction,
                otherWaypoint = _props3.otherWaypoint;

            if (typeof value == "number") {
                this.setSticky(value);return;
            } else if (typeof value == "function") {
                var placeholderDOM = _reactDom2.default.findDOMNode(evalMaybeThunk(placeholder));
                if (placeholderDOM) {

                    var otherVal = undefined;
                    var otherWaypointDOM = _reactDom2.default.findDOMNode(evalMaybeThunk(otherWaypoint));
                    // TODO: sticky should be cleared when otherWaypoint was scrolled
                    //   under the sticky overlay, not the original border
                    if (otherWaypointDOM) {
                        otherVal = otherWaypointDOM.getBoundingClientRect()[otherDirection(direction)];
                    }

                    var ret = value(placeholderDOM.getBoundingClientRect()[direction], otherVal);
                    if (typeof ret == "number") {
                        this.setSticky(ret);return;
                    }
                }
            }
            this.clearSticky();
        }
    }, {
        key: "render",
        value: function render() {
            var ret = _react2.default.Children.only(this.props.children);
            return _react2.default.cloneElement(ret, {
                className: (0, _classnames2.default)(ret.props.className, typeof this.state.sticky == "number" ? "cn-sticky-active cn-sticky-overlay cn-sticky-" + this.props.direction : "")
            });
        }
    }]);
    return Sticky;
}(_react2.default.Component);

Sticky.propTypes = {
    direction: _propTypes2.default.oneOf(["top", "bottom"]),
    placeholder: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
    otherWaypoint: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
    value: _propTypes2.default.func
};
exports.default = Sticky;


Sticky.Placeholder = Placeholder;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table-area@0.0.19@@alicd/crui-table-area/lib/Sticky.js
// module id = 706
// module chunks = 0